import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import { PendingToPayText, Row, Title } from './styles'
import InformationBox from '../InformationBox'
import IconCheckmark from 'client/icons/Checkmark'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'

import { RangeWrapper } from 'client/components/PriceRange/styles'
import Price from 'client/components/Price'

const PayPartialNow = ({ amount, partialAmounts, currency, handleAmount }) => {
  const intl = useIntl()

  return (
    <div>
      <Row>
        <Title>
          <FormattedMessage {...messages.partialPay} />
        </Title>
      </Row>
      <Row>
        <PendingToPayText>
          <FormattedMessage {...messages.partialTitle} tagName="div" />
          <Price amount={amount} currency={currency} />
        </PendingToPayText>
        <RangeWrapper>
          <Slider
            min={partialAmounts.min}
            max={partialAmounts.max}
            defaultValue={amount}
            onChange={handleAmount}
          />
        </RangeWrapper>
      </Row>
      <Row>
        <InformationBox
          icon={<IconCheckmark />}
          text={intl.formatMessage(messages.cancelRemainExplain)}
          title={intl.formatMessage(messages.cancellationPoliciesRemain)}
        />
      </Row>
    </div>
  )
}

PayPartialNow.propTypes = {
  amount: PropTypes.number,
  partialAmounts: PropTypes.instanceOf({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  currency: PropTypes.string,
  handleAmount: PropTypes.func,
}

export default PayPartialNow
